import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsFilterLeadBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsFilterLeadBlockEntity
